import { AxiosError } from 'axios';

import { Interceptor } from 'app/api/interceptor/Interceptor';
import { CreditCardOrderRejectedException } from 'app/api/exception/CreditCardOrderRejectedException';

export class ForbiddenErrorInterceptor implements Interceptor {
    process(error: AxiosError): void {
        if (error.response.status === 403) {
            const payload = error.response
                .data as CreditCardOrderRejectedException;

            throw new CreditCardOrderRejectedException(
                payload.id,
                payload.type,
                payload.message,
                payload.rejectReasons,
                payload.rejectCode,
            );
        }
    }
}
